// Question and answers from the FAQ component

const questions = [
    {
		question: "Do I need to have a club membership to attend events?",
		answer: "For most events you are not required to have a membership, but there a few throughout the year that are membership only.",
	},
	{
		question: "What kinds of resources does CSUS provide for CS students?",
		answer: "CSUS resources vary widely from academic resources such as course prep sessions to career resources such as \nresume review nights and networking opportunities.",
	},
    {
		question: "When do executive applications open?",
		answer: "Computer Science Undergraduate Society, or CSUS, is a club that represents computer science students and provides resources \nand events to better students' experience in computer science.",
	},
	{
		question: "When do executive and director applications open?",
		answer:"Executive applications for VP positions usually open around May, meanwhile director applications open in September!"
	}
]

export default questions;